export const DEPLOY_ENVS = { PROD: 'Prod', UAT: 'Uat', DEV: 'Dev' };
export const isProdEnv = (deployEnv) => deployEnv?.toLowerCase() === DEPLOY_ENVS.PROD.toLowerCase();
//# sourceMappingURL=environment.js.map